import {Component} from 'react';
import h from 'react-hyperscript';
import './Sidebar.scss';
import {subhead, footnote} from 'Components/Typography/Typography';
import MobileMenu from 'Components/MobileMenu/MobileMenu';
import TabHeader from 'Components/TabHeader/TabHeader';

class Sidebar extends Component {
  render() {
    return (
      h('div', {
        id: 'four-cs__sidebar',
      }, [
        h(MobileMenu, {
          key: 'sidebar-mobile__menu',
          id: 'sidebar-mobile__menu',
          selectedIndex: this.props.activeTab,
          anchorEl: this.props.mobileAnchorEl,
          menuList: this.props.items,
          handleMobileMenuOpen: this.props.handleMobileMenuOpen,
          changeContent: this.props.handleTabClick,
          handleMobileMenuClose: this.props.handleMobileMenuClose,
        }, null),

        h('div', {
          id: 'sidebar-desktop__menu',
        }, this.props.items.map((item, i) => {
          const id = item.title.toLowerCase().replace(' ', '_');
          return (
            h(TabHeader, {
              i: i,
              handleTabClick: this.props.handleTabClick,
              inactiveClasses: 'sidebar-item',
              activeTab: this.props.activeTab,
            }, [
              h(subhead, {
                key: `${item.id}-title__key`,
                datatarget: item.id,
              }, item.title),
              h(footnote, {
                key: `sidebar-item-${i}-footnote`,
                className: 'text--grey sidebar__num-products',
              }, `${this.props.fourCs[id].length} Products`),
            ])
          );
        })),
      ])
    );
  }
}

export default Sidebar;
